import { Box, IconButton, Typography } from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';

export default function DetalhesFiltros({
    label,
    value,
    gap,
    isEdit,
    action
}: DetalhesFiltrosProps) {
    return (
        <>
            <Typography variant="caption" sx={{ opacity: 0.7 }}>{label}</Typography>
            <Box display={"flex"} gap={gap} alignItems={'center'}>
                <Typography variant="caption"><b>{value}</b></Typography>
                {
                    isEdit &&
                    <IconButton size="small" aria-label="delete" onClick={action}>
                        <EditIcon fontSize="inherit" sx={{ color: "black" }} />
                    </IconButton>
                }
            </Box>
        </>
    );
}

interface DetalhesFiltrosProps {
    label: string;
    value: any,
    gap: number
    isEdit: boolean
    action: () => void
}